// in src/users.js
import * as React from "react";
import './Logo.css';
import logo from './Logo.svg'

export const Logo = props => (
    <div className='logo'>
        <a href="http://fencing.lv">
            <img src={logo} alt="logo" className='logoImg' /></a>

    </div>
);

export default Logo;